import { render } from "./Tariffs.vue?vue&type=template&id=42b813a3&scoped=true"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"

import "./Tariffs.vue?vue&type=style&index=0&id=42b813a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b813a3"]])

export default __exports__